const labelsForUnitList = (typeOfContent, allLabels) => {
  const {
    unitCompleted,
    unitIncomplete
  } = allLabels;
  let showAndHide = null;
  if (typeOfContent === "project") {
    showAndHide = {
      showNUnits: allLabels.showNSteps,
      hideNUnits: allLabels.hideNSteps
    };
  } else {
    showAndHide = {
      showNUnits: allLabels.showNUnits,
      hideNUnits: allLabels.hideNUnits
    };
  }
  return {
    ...showAndHide,
    unitCompleted,
    unitIncomplete
  };
};
var labelsForUnitList$1 = labelsForUnitList;

export { labelsForUnitList$1 as default };
